module.exports = __webpack_public_path__ + "static/llama-bg-01-tablet-c9869d8e5fab2fd33681c61a0f937d5f.png";